<template>
  <div class="chart">
    <label class="chart__labels">
      <strong class="chart__labels__title">Kostenarten</strong>
      <span
        v-for="(point, i) in points.filter(p => p.value > 0)"
        :key="'l' + i"
        class="chart__labels__item"
      >
        <span
          class="chart__labels__item__square"
          :style="'--fill:' + point.color"
        ></span>
        {{ point.label }}
      </span>
    </label>
    <svg viewBox="0 0 20 20" class="chart__svg">
      <circle r="10" cx="10" cy="10" fill="white" />
      <circle
        class="point"
        v-for="(point, i) in reverseData"
        :key="'p' + i"
        :r="radius"
        cx="10"
        cy="10"
        fill="transparent"
        :stroke="point.color"
        stroke-width="10"
        :stroke-dasharray="strokeDashArray(i)"
        transform="rotate(-90) translate(-20)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "PieChart",
  props: {
    data: Array
  },
  data() {
    return {
      radius: 5
    };
  },
  computed: {
    points() {
      return this.$props.data;
    },
    total() {
      return this.points.reduce((total, current) => total + current.value, 0);
    },
    reverseData() {
      return this.points.slice().reverse();
    }
  },
  methods: {
    strokeDashArray(indexOnReverse) {
      const indexOnNormal = this.points.length - indexOnReverse - 1;

      let value = this.reverseData[indexOnReverse].value;
      for (let j = indexOnNormal - 1; j >= 0; j--)
        value += this.points[j].value;

      const circumference = 2 * Math.PI * this.radius;
      const strokeDash = (value / this.total) * circumference;

      return `${strokeDash.toFixed(10)} ${circumference}`;
    }
  }
};
</script>

<style scoped lang="scss">
.chart {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__svg {
    width: 66.66666%;
  }

  &:hover {
  }

  &__labels {
    display: flex;
    flex-direction: column;
    margin-right: 1rem;

    &__item {
      &__square {
        height: 0.75em;
        width: 0.75em;
        display: inline-block;
        border-radius: 2px;
        margin-right: 0.25rem;
        background-color: black;
        background-color: var(--fill);
      }
    }
  }
}
</style>
